import * as React from 'react';
import { ExtensionComponentProps } from 'piral-core';
import { DisplayError, DisplayErrorProps } from '@piral/portal-utils';

export const DisplayErrorExtension: React.FC<ExtensionComponentProps<DisplayErrorProps>> = ({ params }) => {
  return <DisplayError {...params} />;
};
